export default "__VITE_ASSET__C0uOM7QF__"